import { Controller } from '@hotwired/stimulus'

// Open state the user chose on keep-state elements, keyed by element id. A
// refresh morph resets the server-rendered `hidden` attribute (or recreates
// the element), so the user's choice is restored from here; an element the
// user never toggled keeps its server-rendered state.
const keptOpenStates = new Map()

export default class extends Controller {
  static targets = ['element', 'icon', 'trigger']
  static values = { keepStateAfterMorph: { type: Boolean, default: false } }

  connect () {
    if (this.keepsState) {
      this.restoreKeptState = (event) => {
        if (event.type === 'turbo:morph' || event.target === this.element) this.applyKeptState()
      }
      document.addEventListener('turbo:morph', this.restoreKeptState)
      document.addEventListener('turbo:morph-element', this.restoreKeptState)
      this.applyKeptState()
      return
    }
    this.syncIcons()
  }

  disconnect () {
    if (!this.restoreKeptState) return

    document.removeEventListener('turbo:morph', this.restoreKeptState)
    document.removeEventListener('turbo:morph-element', this.restoreKeptState)
  }

  toggle (e) {
    if (this.shouldSkip(e)) return

    this.elementTargets.forEach((element) => {
      element.hidden = !element.hidden
    })
    this.render()
  }

  show (e) {
    if (this.shouldSkip(e)) return

    this.elementTargets.forEach((element) => {
      element.hidden = false
    })
    this.render()
  }

  hide (e) {
    if (this.shouldSkip(e)) return

    this.elementTargets.forEach((element) => {
      element.hidden = true
    })
    this.render()
  }

  render () {
    this.syncIcons()
    this.rememberState()
  }

  syncIcons () {
    const open = this.isOpen
    this.iconTargets.forEach((icon) => icon.classList.toggle('rotate-180', open))
    this.triggerTargets.forEach((trigger) => trigger.setAttribute('aria-expanded', String(open)))
  }

  shouldSkip (e) {
    return e.target.dataset.displayToggleSkip
  }

  get isOpen () {
    return this.elementTargets.some((element) => !element.hidden)
  }

  get keepsState () {
    return this.keepStateAfterMorphValue && Boolean(this.element.id)
  }

  applyKeptState () {
    if (keptOpenStates.has(this.element.id)) {
      const open = keptOpenStates.get(this.element.id)
      this.elementTargets.forEach((element) => {
        element.hidden = !open
      })
    }
    this.syncIcons()
  }

  rememberState () {
    if (!this.keepsState) return

    keptOpenStates.set(this.element.id, this.isOpen)
  }
}
